__webpack_require__.p = "/GrandMaSam_Diner_renewed/";